export const urlConfig = {
    addTeamMemberHref: 'https://forms.gle/nciPTAhKyNYsjMh47',
    addBrandHref: 'https://forms.gle/vr3BZb9uLWYknk4MA',
    referAFriendHref: 'https://varos.tapfiliate.com',
} as const;
